<!-- formGroup is built asynchronously in initForm() (via loadedExtension$); guard so the child's
     [formGroup] directive never binds to undefined during the first change-detection pass (NG01052). -->
@if (formGroup) {
  <cart-control-form
    [formGroup]="formGroup"
    [displayRules]="displayRules"
    [displayRulesEntities]="displayRulesEntities"
    [shopCurrencySymbol]="shopCurrencySymbol"></cart-control-form>
}
